import { atom } from 'recoil'

import { ViewStateSelection } from 'lib/interfaces'

export const viewState = atom<ViewStateSelection>({
  key: 'ViewState',
  default: 'trading',
})
